import { ArrowRight } from "lucide-react";

const steps = [
  {
    n: "01",
    t: "Uitkeringsbestand",
    d: "Casemanager of klantmanager selecteert en verwijst door.",
  },
  {
    n: "02",
    t: "LevelLeven",
    d: "START & VERDER, beweging, structuur, perspectief.",
    highlight: true,
  },
  {
    n: "03",
    t: "Vervolgtrajecten",
    d: "Re-integratie, opleiding, vrijwilligerswerk, werkgever.",
  },
];

export default function PositieInKeten() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-11 gap-3 items-stretch">
      {steps.map((s, i) => (
        <div
          key={s.n}
          className={`md:col-span-3 rounded-2xl p-6 sm:p-7 border transition-colors ${
            s.highlight
              ? "bg-[#1D2A22] text-[#FAF7F1] border-[#1D2A22]"
              : "bg-[#FAF7F1] border-[#E5E1D8]"
          }`}
        >
          <p
            className={`text-xs uppercase tracking-[0.25em] mb-3 ${
              s.highlight ? "text-[#D19B72]" : "text-[#E06B3F]"
            }`}
          >
            {s.n}
          </p>
          <p className="font-heading text-2xl leading-tight">{s.t}</p>
          <p
            className={`mt-3 text-sm leading-relaxed ${
              s.highlight ? "text-[#FAF7F1]/80" : "text-[#4A5D4E]"
            }`}
          >
            {s.d}
          </p>
        </div>
      ))}
      {/* connector */}
      <div className="hidden md:flex md:col-span-1 items-center justify-center order-2 md:order-none">
        <ArrowRight className="text-[#E06B3F]" size={22} />
      </div>
      <div className="hidden md:flex md:col-span-1 items-center justify-center order-4 md:order-none">
        <ArrowRight className="text-[#E06B3F]" size={22} />
      </div>
    </div>
  );
}
